import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=32eaf7e9&scoped=true"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=32eaf7e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eaf7e9",
  null
  
)

export default component.exports